var render = function render(){var _vm=this,_c=_vm._self._c;return _c('nav',{staticClass:"nav-anchors",class:[
    _vm.size,
    { 'nav-pills': _vm.pills, },
  ],attrs:{"id":_vm.navId}},[_c('ul',_vm._l((_vm.navTitles),function(title){return _c('li',{key:title.anchorId},[_c('Anchor',{attrs:{"label":title.label,"anchor-id":`#${title.anchorId}`},scopedSlots:_vm._u([(title.icon)?{key:"icon",fn:function(){return [_c(title.icon,{tag:"component"})]},proxy:true}:null],null,true)})],1)}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }